export default __webpack_public_path__ + "static/Hero_04_Operations_REV-8fd02c7584cafaf4bad2561df41740f6.jpg";